export const ACLS = {
	POSTS: {
		CREATE: 'posts:create',
		READ: 'posts:read',
		LIST: 'posts:list',
		UPDATE: 'posts:update',
		DELETE: 'posts:delete',
	},
	OFFSETS: {
		CREATE: 'offsets:create',
		READ: 'offsets:read',
		LIST: 'offsets:list',
		UPDATE: 'offsets:update',
		DELETE: 'offsets:delete',
	},
	USERS: {
		CREATE: 'users:create',
		READ: 'users:read',
		LIST: 'users:list',
		UPDATE: 'users:update',
		DELETE: 'users:delete',
		ACTIVATE: 'users:activate',
		FORGOT_PASSWORD: 'users:forgot_password',
		UPDATE_PASSWORD: 'users:update_password',
		UPDATE_EMAIL: 'users:update_email',
		RESET_EMAIL: 'users:reset_email',
		DISABLE: 'users:disable',
		ENABLE: 'users:enable',
	},
	ORGANIZATIONS: {
		CREATE: 'organizations:create',
		READ: 'organizations:read',
		LIST: 'organizations:list',
		UPDATE: 'organizations:update',
		DELETE: 'organizations:delete',
	},
	API_TOKENS: {
		CREATE: 'api_tokens:create',
		READ: 'api_tokens:read',
		LIST: 'api_tokens:list',
		UPDATE: 'api_tokens:update',
		DELETE: 'api_tokens:delete',
	},
	MINT_HISTORIES: {
		CREATE: 'aco2_tokens:create',
		READ: 'aco2_tokens:read',
		LIST: 'aco2_tokens:list',
		UPDATE: 'aco2_tokens:update',
	},
	IMPORT_HISTORIES: {
		CREATE: 'import_histories:create',
		READ: 'import_histories:read',
		LIST: 'import_histories:list',
		UPDATE: 'import_histories:update',
	},
	ENTITIES: {
		READ: 'entities:read',
		LIST: 'entities:list',
		CREATE: '',
		UPDATE: '',
		DELETE: '',
	},
	BRANDS: {
		CREATE: 'brands:create',
		READ: 'brands:read',
		LIST: 'brands:list',
		UPDATE: 'brands:update',
		DELETE: 'brands:delete',
		VERIFY: 'brands:verify',
		UNVERIFY: 'brands:unverify',
	},
	PRODUCERS: {
		CREATE: 'producers:create',
		READ: 'producers:read',
		LIST: 'producers:list',
		UPDATE: 'producers:update',
		DELETE: 'producers:delete',
		VERIFY: 'producers:verify',
		UNVERIFY: 'producers:unverify',
	},
	ROLES: {
		CREATE: 'roles:create',
		READ: 'roles:read',
		LIST: 'roles:list',
		UPDATE: 'roles:update',
		DELETE: 'roles:delete',
	},
	PROJECTS: {
		READ: 'projects:read',
		LIST: 'projects:list',
		LIST_PARENT_ORGANIZATIONS:
			'projects:listParentOrganizations',
		LIST_PARENT_PRODUCERS: 'projects:listParentProducers',
		CREATE: '',
		UPDATE: '',
		DELETE: '',
	},
	MEASURABILITIES: {
		CREATE: 'measurabilities:create',
		READ: 'measurabilities:read',
		LIST: 'measurabilities:list',
		LIST_PARENT_ORGANIZATIONS:
			'measurabilities:listParentOrganizations',
		LIST_PARENT_PRODUCERS:
			'measurabilities:listParentProducers',
		UPDATE: 'measurabilities:update',
		DELETE: 'measurabilities:delete',
		ACTIVATE: 'measurabilities:activate',
		SYNC_QUANTITY: 'measurabilities:syncQuantity',
	},
	ADDITIONALITIES: {
		CREATE: 'additionalities:create',
		READ: 'additionalities:read',
		LIST: 'additionalities:list',
		LIST_PARENT_ORGANIZATIONS:
			'additionalities:listParentOrganizations',
		LIST_PARENT_PRODUCERS:
			'additionalities:listParentProducers',
		UPDATE: 'additionalities:update',
		DELETE: 'additionalities:delete',
		ACTIVATE: 'additionalities:activate',
		SYNC_FINANCING: 'additionalities:syncFinancing',
	},
	SITES: {
		CREATE: 'sites:create',
		READ: 'sites:read',
		LIST: 'sites:list',
		UPDATE: 'sites:update',
		DELETE: 'sites:delete',
	},
	METER_POINTS: {
		CREATE: 'meter_points:create',
		READ: 'meter_points:read',
		LIST: 'meter_points:list',
		UPDATE: 'meter_points:update',
		DELETE: 'meter_points:delete',
	},
	PRODUCTIONS: {
		CREATE: 'productions:create',
		READ: 'productions:read',
		LIST: 'productions:list',
		DELETE: 'productions:delete',
		DELETE_MULTIPLE: 'productions:deleteMultiple',
		VERIFY: 'productions:verify',
		UNVERIFY: 'productions:unverify',
		ADMIN: 'productions:admin',
	},
	CONVERSION_FACTORS: {
		CREATE: 'conversion_factors:create',
		READ: 'conversion_factors:read',
		LIST: 'conversion_factors:list',
		DELETE: 'conversion_factors:delete',
		UPDATE: '',
	},
	PUBLIC_ORGANIZATIONS: {
		READ: 'public_organizations:read',
		LIST: 'public_organizations:list',
	},
	PUBLIC_ENTITIES: {
		READ: 'public_entities:read',
		LIST: 'public_entities:list',
	},
	PUBLIC_PROJECTS: {
		READ: 'public_projects:read',
		LIST: 'public_projects:list',
	},
	PUBLIC_MEASURABILITIES: {
		READ: 'public_measurabilities:read',
		LIST: 'public_measurabilities:list',
	},
	PUBLIC_ADDITIONALITIES: {
		READ: 'public_measurabilities:read',
		LIST: 'public_measurabilities:list',
	},
	FRONT: {
		DASHBOARD: {
			KPI_COMPENSATED_EMISSIONS:
				'dashboard:front:kpi_compensated_emissions',
			KPI_TOTAL_COMPONSATION:
				'dashboard:front:kpi_total_compensation',
			KPI_FINANCING_OF_ADDITIONALITY:
				'dashboard:front:kpi_financing_of_additionality',
			REQUEST_CARBON_ASSESSMENT:
				'dashboard:front:request_carbon_assessment',
			FILTER_DATE: 'dashboard:front:filter_date',
			FILTER_COMPANIES:
				'dashboard:front:filter_companies',
			FILTER_PROJECTS: 'dashboard:front:filter_projects',
			DONUTCHART: 'dashboard:front:donut_chart',
			LAST_OFFSETS_LIST:
				'dashboard:front:last_offsets_list',
			LAST_PRODUCTIONS_LIST:
				'dashboard:front:last_productions_list',
			LAST_NEWS: 'dashboard:front:last_news',
		},
		OFFSETS: {
			FILTER: 'offsets:front:filter',
			FILTER_DATE: 'offsets:front:filter_date',
			FILTER_BRANDS: 'offsets:front:filter_brands',
		},
		BRANDS: {
			FILTER: 'brands:front:filter',
			FILTER_STATUS: 'brands:front:filter_status',
			FILTER_COUNTRIES: 'brands:front:filter_countries',
			FILTER_ORGANIZATIONS:
				'brands:front:filter_organizations',
		},
		PRODUCERS: {
			FILTER: 'producers:front:filter',
			FILTER_STATUS: 'producers:front:filter_status',
			FILTER_COUNTRIES:
				'producers:front:filter_countries',
			FILTER_ORGANIZATIONS:
				'producers:front:filter_organizations',
		},
		PRODUCTIONS: {
			FILTER: 'productions:front:filter',
			FILTER_VERIFIED_STATUS:
				'productions:front:filter_verified_status',
			FILTER_MINTED_STATUS:
				'productions:front:filter_minted_status',
			FILTER_DATE: 'productions:front:filter_date',
			FILTER_PROJECTS:
				'productions:front:filter_projects',
			FILTER_SITES: 'productions:front:filter_sites',
			FILTER_QUANTITY_ALERT:
				'productions:front:filter_quantity_alert',
		},
		MEASURABILITIES: {
			FILTER: 'measurabilities:front:filter',
			FILTER_STATUS:
				'measurabilities:front:filter_status',
			FILTER_COUNTRIES:
				'measurabilities:front:filter_countries',
			FILTER_TECHNOLOGIES:
				'measurabilities:front:filter_technologies',
			FILTER_RANGE_PRICE_PER_TONE:
				'measurabilities:front:filter_range_price_per_tonne',
			FILTER_RANGE_AVAILABLE_STOCK:
				'measurabilities:front:filter_range_available_stock',
			TOGGLE_VIEW_MODE:
				'measurabilities:front:toggle_view_grid_list',
			EDIT_BUTTON: 'measurabilities:front:edit_button',
			STATUS_TAG: 'measurabilities:front:status_tag',
			TAB_GENERAL_INFORMATIONS:
				'measurabilities:front:tab_general_information',
			TAB_TRANSACTION_HISTORY:
				'measurabilities:front:tab_transaction_history',
			TAB_SITES: 'measurabilities:front:tab_sites',
		},
		ADDITIONALITIES: {
			FILTER: 'additionalities:front:filter',
			FILTER_STATUS:
				'additionalities:front:filter_status',
			FILTER_COUNTRIES:
				'additionalities:front:filter_countries',
			FILTER_TECHNOLOGIES:
				'additionalities:front:filter_technologies',
			FILTER_RANGE_PRICE_PER_TONE:
				'additionalities:front:filter_range_price_per_tonne',
			FILTER_RANGE_AVAILABLE_STOCK:
				'additionalities:front:filter_range_available_stock',
			TOGGLE_VIEW_MODE:
				'additionalities:front:toggle_view_grid_list',
			EDIT_BUTTON: 'additionalities:front:edit_button',
			STATUS_TAG: 'additionalities:front:status_tag',
			TAB_GENERAL_INFORMATIONS:
				'additionalities:front:tab_general_information',
			TAB_TRANSACTION_HISTORY:
				'additionalities:front:tab_transaction_history',
			TAB_SITES: 'additionalities:front:tab_sites',
		},
	},
} as const;
